import client from '../client';
import endpoints from '../endpoints';

/**
 * 쇼핑 — 서비스 + 관리자 API
 * API_DOCS: 10. 쇼핑 / 24. 관리자 - 쇼핑
 */

/* ── 서비스 (유저용) ── */

export const getRetailProducts = async (params = {}) => {
  const res = await client.get(endpoints.shopping.products, { params });
  return res.data;
};

const CATEGORY_LABELS = { oliveyoung: '올리브영', daiso: '다이소', mart: '마트', other: '기타' };
export const getRetailCategories = async () => {
  const res = await client.get(endpoints.shopping.products);
  const cats = [...new Set(res.data.map((p) => p.category).filter(Boolean))];
  return cats.map((c) => ({ id: c, label: CATEGORY_LABELS[c] || c }));
};

export const getShoppingProducts = async (params = {}) => {
  const res = await client.get(endpoints.shopping.products, { params });
  return res.data;
};

export const getShoppingProductById = async (id) => {
  const res = await client.get(endpoints.shopping.productDetail(id));
  return res.data;
};

export const getCart = async () => {
  const res = await client.get(endpoints.shopping.cart);
  return res.data;
};

export const addToCart = async (data) => {
  const res = await client.post(endpoints.shopping.cart, data);
  return res.data;
};

export const updateCartItem = async (cartId, data) => {
  const res = await client.put(endpoints.shopping.cartItem(cartId), data);
  return res.data;
};

export const deleteCartItem = async (cartId) => {
  const res = await client.delete(endpoints.shopping.cartItem(cartId));
  return res.data;
};

export const createOrder = async (data) => {
  const res = await client.post(endpoints.shopping.orders, data);
  return res.data;
};

export const getOrders = async (params = {}) => {
  const res = await client.get(endpoints.shopping.orders, { params });
  return res.data;
};

// email: 비회원 게스트(OTP 인증) 조회 시 booker_email 동봉
export const getOrderById = async (id, email) => {
  const res = await client.get(endpoints.shopping.orderDetail(id), email ? { params: { email } } : undefined);
  return res.data;
};

// [유형1] 고객 환불/취소 요청 — { items:[{item_id, quantity}], note?, refund_account? }
// email: 비회원 게스트(OTP 인증) 요청 시 booker_email 동봉
export const requestShoppingRefund = async (orderId, data, email) => {
  const res = await client.post(endpoints.shopping.refundRequest(orderId), data, email ? { params: { email } } : undefined);
  return res.data;
};

/* ── 관리자 ── */

export const getAdminProducts = async (params = {}) => {
  const res = await client.get(endpoints.admin.shopping.products, { params });
  return res.data;
};

export const createAdminProduct = async (data) => {
  const res = await client.post(endpoints.admin.shopping.products, data);
  return res.data;
};

export const updateAdminProduct = async (id, data) => {
  const res = await client.put(endpoints.admin.shopping.productDetail(id), data);
  return res.data;
};

export const deleteAdminProduct = async (id) => {
  const res = await client.delete(endpoints.admin.shopping.productDetail(id));
  return res.data;
};

export const getAdminOrders = async (params = {}) => {
  const res = await client.get(endpoints.admin.shopping.orders, { params });
  return res.data;
};

export const updateAdminOrderStatus = async (id, status) => {
  const res = await client.put(endpoints.admin.shopping.orderStatus(id), { status });
  return res.data;
};

// 관리자 주문 상세 (품목·환불수량·잔여·환불이력·결제수단 포함)
export const getAdminOrderDetail = async (id) => {
  const res = await client.get(endpoints.admin.shopping.orderDetail(id));
  return res.data;
};

// [유형2] 운영자 부분환불 — { items:[{item_id, quantity}], reason, note?, refund_account? }
export const operatorRefund = async (orderId, data) => {
  const res = await client.post(endpoints.admin.shopping.orderRefund(orderId), data);
  return res.data;
};

// 고객 환불요청 목록 — params: { status, page, size }
export const getRefundRequests = async (params = {}) => {
  const res = await client.get(endpoints.admin.shopping.refundRequests, { params });
  return res.data;
};

// [유형1] 환불요청 승인 — { items?, refund_account? }
export const approveRefundRequest = async (requestId, data = {}) => {
  const res = await client.post(endpoints.admin.shopping.refundApprove(requestId), data);
  return res.data;
};

// [유형1] 환불요청 반려 — { rejection_reason }
export const rejectRefundRequest = async (requestId, data) => {
  const res = await client.post(endpoints.admin.shopping.refundReject(requestId), data);
  return res.data;
};
